import { useGetEventFeatureFlagsQuery } from '@graphql/generated';
import { useQueryParamHelper } from '@shared/core/queryString';
import { useCallback } from 'react';

export const useEventFeatureFlags = ({ eventHandle }: { eventHandle: string }) => {
  const { data, loading } = useGetEventFeatureFlagsQuery({
    variables: { eventHandle },
    batchMode: 'fast',
  });

  const { getValueString } = useQueryParamHelper();
  const isEventFeatureFlagEnabledViaQueryParam = useCallback(
    (flag: string) => {
      return getValueString(`feature.${flag}`) === 'true';
    },
    [getValueString],
  );

  const isEventFeatureFlagEnabled = useCallback(
    (flag: string) => {
      return data?.eventByName?.featureFlags?.includes(flag) || isEventFeatureFlagEnabledViaQueryParam(flag);
    },
    [data, isEventFeatureFlagEnabledViaQueryParam],
  );

  return {
    loadingEventFeatureFlags: loading,
    isEventFeatureFlagEnabled,
  };
};
